import { gql } from '@apollo/client'
import type { TypedDocumentNode } from '@graphql-typed-document-node/core'

import type {
    UpdateAttendEventStateMutation,
    UpdateAttendEventStateMutationVariables,
} from './ConfirmAttend.mutations.generated'

export const CONFIRM_ATTEND_EVENT: TypedDocumentNode<
    UpdateAttendEventStateMutation,
    UpdateAttendEventStateMutationVariables
> = gql`
    mutation updateAttendEventState($input: updateAttendEventStateInput!) {
        updateAttendEventState(input: $input) {
            entity {
                guid
            }
        }
    }
`
